//#region Angular Imports

import { StateProvider } from '@uirouter/angularjs'

//#endregion

import { UserSession } from '../../helpers/user-session'
import { Activity } from '../../models/common/activity'
import { OpOperator } from '../../models/core'

import { default as commonModule } from './../common/common.module'
import { default as apiModule, Api } from './../api/api.module'
import { MenuItem } from '../common/sidebar-menu/common.sidebar-menu.directive'

import { SettingsController } from './settings.controller'

//#region Asset Imports

import './settings.scss'
import * as TEMPLATE from './settings.tpl.html'

//#endregion

var moduleName = 'simax.settings'
var module = angular.module(moduleName, [commonModule, apiModule])

module.controller('SettingsController', ['$scope', '$timeout', 'api', 'userSession', ($scope, $timeout, api: Api, userSession) => new SettingsController($scope, $timeout, api, userSession)])

module.config(['$stateProvider', 'userSessionProvider', ($stateProvider: StateProvider, userSessionProvider: UserSession) => {
    userSessionProvider
        .getLoggedOperatorAsync()
        .then((loggedOperator: OpOperator) => {
            if (loggedOperator.hasPermission(Activity.SETTINGS_LIST)) {
                MenuItem.addMenuItem(window['config']['ICONS']['SETTINGS'], 'settings', 'Settings', 'settings', 50)

                $stateProvider.state('settings', {
                    url: "/settings",
                    controller: 'SettingsController',
                    template: TEMPLATE,
                    params: { ids: null }
                })
            }
        })
}])

export default moduleName